var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social logos / yt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 31.9998719 0 31.9998719 32 0 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 32 32 32 32 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-1.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing",
    transform: "translate(-704.000000, -12291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 12191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social_icons",
    transform: "translate(617.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-logos-/-yt",
    transform: "translate(87.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000128, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7087955,-0.000213581087 L9.29120446,-0.000213581087 C4.15970526,-0.000213581087 0,4.15949168 0,9.29099088 L0,22.708582 C0,27.8400812 4.15970526,32.0002136 9.29120446,32.0002136 L22.7087955,32.0002136 C27.8402947,32.0002136 32,27.8400812 32,22.708582 L32,9.29099088 C32,4.15949168 27.8402947,-0.000213581087 22.7087955,-0.000213581087",
    id: "Fill-1",
    fill: "#242424",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.75680295,14.9035512 L17.9679643,9.85765929 C19.1733579,9.33204556 23.2612145,7.65008159 23.2612145,7.65008159 C23.2612145,7.65008159 25.1479175,6.91422236 24.9906923,8.70130907 C24.9382838,9.4371683 24.5190165,12.0126756 24.0997492,14.7984284 L22.7895387,23.0505641 C22.7895387,23.0505641 22.6847219,24.2594757 21.7937788,24.4697212 C20.9028357,24.6799667 19.4354,23.733862 19.1733579,23.5236165 C18.9637242,23.3659324 15.2427266,21.0006705 13.8801077,19.8443203 C13.5132488,19.5289521 13.0939814,18.8982156 13.9325161,18.1623564 C15.8192192,16.427831 18.0727811,14.2728147 19.4354,12.906219 C20.064301,12.2754825 20.693202,10.803764 18.0727811,12.5908507 L10.6831942,17.5841812 C10.6831942,17.5841812 9.84465954,18.109795 8.272407,17.6367426 C6.70015447,17.1636903 4.86585985,16.5329538 4.86585985,16.5329538 C4.86585985,16.5329538 3.60805782,15.7445332 5.75680295,14.9035512 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.4820b7f6ad37962b53b24e26caa9d909.svg";
export { ForwardRef as ReactComponent };